import { render } from "./ChartOfAccount.vue?vue&type=template&id=45a288a2&scoped=true"
import script from "./ChartOfAccount.vue?vue&type=script&lang=js"
export * from "./ChartOfAccount.vue?vue&type=script&lang=js"

import "./ChartOfAccount.vue?vue&type=style&index=0&id=45a288a2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a288a2"]])

export default __exports__